import { load } from '@iheartjane/utils';
import { Outlet } from 'react-router';
import type { RouteObject } from 'react-router';

import { RequireAnonymousUser } from '@jane/business-admin/components/auth/RequireAnonymousUser';

const Login = load(() => import('@jane/business-admin/pages/Login'), 'Login');
const SsoCallback = load(
  () => import('@jane/business-admin/pages/SsoCallback'),
  'SsoCallback'
);
const RequestPasswordReset = load(
  () => import('@jane/business-admin/pages/RequestPasswordReset'),
  'RequestPasswordReset'
);
const ResetPassword = load(
  () => import('@jane/business-admin/pages/ResetPassword'),
  'ResetPassword'
);
const ManagerRegistration = load(
  () => import('@jane/business-admin/pages/ManagerRegistration'),
  'ManagerRegistration'
);

export const authRoutes = (): RouteObject[] => [
  {
    element: (
      <RequireAnonymousUser>
        <Outlet />
      </RequireAnonymousUser>
    ),
    children: [
      {
        path: '/register',
        element: <ManagerRegistration />,
      },
      {
        path: '/login',
        element: <Login />,
      },
      {
        path: '/sso/callback',
        element: <SsoCallback />,
      },
      {
        path: '/forgot-your-password',
        element: <RequestPasswordReset />,
      },
      {
        path: '/reset-password/:token',
        element: <ResetPassword />,
      },
    ],
  },
];
